// src/components/molecules/MoleculePopupColor.jsx
import React, { useState } from "react";
import styled, { css } from "styled-components";

const Overlay = styled.div`
  width: 88px; /* 2칸 * (25px + gap) + padding */
  padding: 8px;
  background: white;
  box-shadow: 0px 2px 7px rgba(0,0,0,0.25);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const ChipsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 12px;
`;

const Chip = styled.button`
  width: 28px;
  height: 28px;
  background: ${props => props.bg};
  border-radius: 4px;
  border: 2px solid transparent;
  padding: 0;
  cursor: pointer;
  transition: filter 0.1s;

  &:hover {
    filter: brightness(1.1);
  }

  ${props => props.selected && css`
    border-color: ${props.border};
  `}
`;

const ConfirmButton = styled.button`
  width: 100%;
  height: 32px;
  background: ${props => props.disabled ? "var(--Grays-Gray-5, #E5E5EA)" : "#256EF4"};
  color: white;
  font-size: 17px;
  border: none;
  border-radius: 6px;
  cursor: ${props => props.disabled ? "default" : "pointer"};
  opacity: ${props => props.disabled ? 0.6 : 1};
`;

export default function MoleculePopupColor({ 
  colors = [
    { bg: "#D5E7FF", border: "#4896FF" },
    { bg: "#ECF2FE", border: "#88B0FF" },
    { bg: "#D2FEFD", border: "#74F3F0" },
    { bg: "#DDF7E5", border: "#6FF097" },
    { bg: "#E8F9D1", border: "#A9EA50" },
    { bg: "#FFF6C5", border: "#FFDD23" },
    { bg: "#FFEED7", border: "#FEC87F" },
    { bg: "#FFE3E6", border: "#FC959F" },
    { bg: "#FCF0FF", border: "#EC9EFF" },
    { bg: "#EADCF8", border: "#CD9BFF" },
  ],
  onConfirm = selectedColor => console.log("confirmed:", selectedColor)
}) {
  const [selectedIdx, setSelectedIdx] = useState(null);

  const handleConfirm = () => {
    if (selectedIdx !== null) {
      onConfirm(colors[selectedIdx]);
    }
  };

  return (
    <Overlay>
      <ChipsGrid>
        {colors.map((c, i) => (
          <Chip
            key={i}
            bg={c.bg}
            border={c.border}
            selected={i === selectedIdx}
            onClick={() => setSelectedIdx(i)}
          />
        ))}
      </ChipsGrid>
      <ConfirmButton
        disabled={selectedIdx === null}
        onClick={handleConfirm}
      >
        확인
      </ConfirmButton>
    </Overlay>
  );
}
